<h2>Cryptowars</h2>
<p>
	Ogni anno organizziamo le cryptowars, ovvero
	delle gare crittografiche rivolte agli studenti.
	Alcune di queste sono realizzate in collaborazione con altri enti,
	come <a href="https://clusit.it/">CLUSIT</a> ed <a href="https://www.enisa.europa.eu/">ENISA</a>.
</p>
<ul>
	<li><a [routerLink]="['/attivita/cryptowars/2021']">Edizione 2021</a></li>
	<li><a [routerLink]="['/attivita/cryptowars/2020']">Edizione 2020</a></li>
	<li><a [routerLink]="['/attivita/cryptowars/2019']">Edizione 2019</a></li>
	<li><a [routerLink]="['/attivita/cryptowars/2018']">Edizione 2018</a></li>
	<li><a [routerLink]="['/attivita/cryptowars/2016']">Edizione 2016</a></li>
	<li><a [routerLink]="['/attivita/cryptowars/2015']">Edizione 2015</a></li>
	<li><a [routerLink]="['/attivita/cryptowars/2014']">Edizione 2014</a></li>
	<li><a [routerLink]="['/attivita/cryptowars/2011']">Edizione 2011</a></li>
</ul>